module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e1f6c5e7d686336bc412de60221f076c.png";